/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  props: ["value"],
  data() {
    return {
      search: "",
      showing: false,
      countries: allCountries,
      billetInstallments: window.product.billet_installments && window.product.billet_installments > 1
    }
  },
  computed: {
    countriesToShow() {
      var search = this.search.toLowerCase();
      return this.countries.filter(function(country) {
        return country.name.toLowerCase().indexOf(search) >= 0;
      })
    }
  },
  methods: {
    select(country) {
      this.$emit("input", country);
      this.country = country;
      this.showing = false;
    },
    toggle() {
      this.showing = !this.showing;
      if (this.showing) {
        setTimeout(() => {
          if (this.$refs.input) {
            this.$refs.input.focus();
          }
        }, 2);
      }
    },
    clickOutside (event) {
      this.showing = false
    }
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickOutside,
          expression: "clickOutside",
        },
      ],
      staticClass: "country-selector",
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-toggle",
          attrs: { type: "button" },
          on: { click: _vm.toggle },
        },
        [
          _c("div", { staticClass: "vti__flag", class: _vm.value.iso2 }),
          _vm._v(" "),
          _c("span", { staticClass: "d-none d-lg-inline mr-2" }, [
            _vm._v("Alterar país"),
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "icon-caret-down" }),
        ]
      ),
      _vm._v(" "),
      _vm.billetInstallments && _vm.showing
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _vm._v(
                "\n      Este produto é exclusivo para vendas no Brasil\n    "
              ),
            ]),
          ])
        : _vm.showing
        ? _c(
            "div",
            { staticClass: "card" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search",
                  },
                ],
                ref: "input",
                attrs: { type: "text", placeholder: "Pesquisar..." },
                domProps: { value: _vm.search },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.countriesToShow, function (country) {
                return _c(
                  "button",
                  {
                    staticClass: "item",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.select(country)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "vti__flag",
                      class: country.iso2,
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(country.name))]),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0ab07bee_0", { source: ".country-selector {\n  top: 12px;\n  right: 16px;\n}\n@media screen and (max-width: 991px) {\n.country-selector {\n    top: 16px;\n}\n}\n.country-selector .btn-toggle {\n  background: none;\n  border: none;\n  padding: 0;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n@media screen and (max-width: 991px) {\n.country-selector .btn-toggle span {\n    font-size: 12px;\n}\n}\n.country-selector .btn-toggle:focus {\n  box-shadow: none !important;\n}\n.country-selector .card {\n  border-radius: 16px !important;\n  position: absolute;\n  z-index: 1;\n  max-height: 300px;\n  overflow-y: scroll;\n  width: 300px;\n  right: 0;\n  top: 30px;\n  padding: 4px 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;\n}\n.country-selector .card input {\n  background: transparent;\n  padding: 6px 12px;\n  border: none;\n}\n.country-selector .card .item {\n  padding: 6px 12px;\n  padding: 6px 12px;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  background: white;\n  border: none;\n}\n.country-selector .card .item:hover {\n  background-color: rgba(100, 100, 100, 0.1);\n}\n.country-selector .card .item i {\n  font-size: 8px;\n}\n\n/*# sourceMappingURL=country-selector.vue.map */", map: {"version":3,"sources":["frontend/components/country-selector.vue","country-selector.vue"],"names":[],"mappings":"AAiEA;EAEA,SAAA;EACA,WAAA;ACjEA;ADmEA;AALA;IAMA,SAAA;AChEE;AACF;ADkEA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AChEA;ADmEA;AADA;IAEA,eAAA;AChEE;AACF;ADmEA;EACA,2BAAA;ACjEA;ADqEA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,oDAAA;ACnEA;ADqEA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;ACnEA;ADsEA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;ACpEA;ADsEA;EACA,0CAAA;ACpEA;ADuEA;EACA,cAAA;ACrEA;;AAEA,+CAA+C","file":"country-selector.vue","sourcesContent":["<template>\n  <div class=\"country-selector\" v-click-outside=\"clickOutside\">\n    <button class=\"btn btn-toggle\" @click=\"toggle\" type=\"button\">\n      <div class=\"vti__flag\" :class=\"value.iso2\"></div>\n      <span class=\"d-none d-lg-inline mr-2\">Alterar país</span>\n      <i class=\"icon-caret-down\"></i>\n    </button>\n    <div v-if=\"billetInstallments && showing\" class=\"card\">\n      <div class=\"card-body\">\n        Este produto é exclusivo para vendas no Brasil\n      </div>\n    </div>\n    <div v-else-if=\"showing\" class=\"card\">\n      <input ref=\"input\" type=\"text\" v-model=\"search\" placeholder=\"Pesquisar...\" />\n      <button v-for=\"country in countriesToShow\" class=\"item\" type=\"button\" @click=\"select(country)\">\n        <div class=\"vti__flag\" :class=\"country.iso2\"></div>\n        <span>{{ country.name }}</span>\n      </button>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: [\"value\"],\n  data() {\n    return {\n      search: \"\",\n      showing: false,\n      countries: allCountries,\n      billetInstallments: window.product.billet_installments && window.product.billet_installments > 1\n    }\n  },\n  computed: {\n    countriesToShow() {\n      var search = this.search.toLowerCase();\n      return this.countries.filter(function(country) {\n        return country.name.toLowerCase().indexOf(search) >= 0;\n      })\n    }\n  },\n  methods: {\n    select(country) {\n      this.$emit(\"input\", country);\n      this.country = country;\n      this.showing = false;\n    },\n    toggle() {\n      this.showing = !this.showing;\n      if (this.showing) {\n        setTimeout(() => {\n          if (this.$refs.input) {\n            this.$refs.input.focus();\n          }\n        }, 2);\n      }\n    },\n    clickOutside (event) {\n      this.showing = false\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\">\n.country-selector {\n  // position: absolute;\n  top: 12px;\n  right: 16px;\n\n  @media screen and (max-width: 991px) {\n    top: 16px;\n  }\n\n  .btn-toggle {\n    background: none;\n    border: none;\n    padding: 0;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n\n    span {\n      @media screen and (max-width: 991px) {\n        font-size: 12px;\n      }\n    }\n\n    &:focus {\n      box-shadow: none !important;\n    }\n  }\n\n  .card {\n    border-radius: 16px !important;\n    position: absolute;\n    z-index: 1;\n    max-height: 300px;\n    overflow-y: scroll;\n    width: 300px;\n    right: 0;\n    top: 30px;\n    padding: 4px 0;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;\n\n    input {\n      background: transparent;\n      padding: 6px 12px;\n      border: none;\n    }\n\n    .item {\n      padding: 6px 12px;\n      padding: 6px 12px;\n      display: flex;\n      align-items: center;\n      text-align: left;\n      background: white;\n      border: none;\n\n      &:hover {\n        background-color: rgba(100, 100, 100, 0.1);\n      }\n\n      i {\n        font-size: 8px;\n      }\n    }\n  }\n}\n</style>",".country-selector {\n  top: 12px;\n  right: 16px;\n}\n@media screen and (max-width: 991px) {\n  .country-selector {\n    top: 16px;\n  }\n}\n.country-selector .btn-toggle {\n  background: none;\n  border: none;\n  padding: 0;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n@media screen and (max-width: 991px) {\n  .country-selector .btn-toggle span {\n    font-size: 12px;\n  }\n}\n.country-selector .btn-toggle:focus {\n  box-shadow: none !important;\n}\n.country-selector .card {\n  border-radius: 16px !important;\n  position: absolute;\n  z-index: 1;\n  max-height: 300px;\n  overflow-y: scroll;\n  width: 300px;\n  right: 0;\n  top: 30px;\n  padding: 4px 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;\n}\n.country-selector .card input {\n  background: transparent;\n  padding: 6px 12px;\n  border: none;\n}\n.country-selector .card .item {\n  padding: 6px 12px;\n  padding: 6px 12px;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  background: white;\n  border: none;\n}\n.country-selector .card .item:hover {\n  background-color: rgba(100, 100, 100, 0.1);\n}\n.country-selector .card .item i {\n  font-size: 8px;\n}\n\n/*# sourceMappingURL=country-selector.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/country-selector.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__